export default __webpack_public_path__ + "static/media/gallery_08.25278ad0.jpg";